/*
 * EP — product card "add to cart" fix (standalone)
 * ---------------------------------------------------------------------------
 * Theme ki koi mojooda file modify nahi hoti. Sirf yeh file add karni hai.
 *
 * ASAL MASLA
 * ----------
 * theme.js bilkul theek load hoti hai aur <form is="product-form"> register bhi
 * hota hai. Lekin theme ki ProductForm class ka connectedCallback yeh karta hai:
 *
 *     connectedCallback() { this.id.disabled = false }
 *
 * Yahan `this.id` ka matlab hai form ke andar wala input jiska name="id" hai
 * (legacy form-control lookup). Yeh sirf tab kaam karta hai jab form pe khud
 * koi id attribute na ho.
 *
 * product-card.liquid aur EP-product-carousel.liquid mein form aise banta hai:
 *
 *     {%- form 'product', product, is: 'product-form' -%}
 *
 * yani bina `id:` ke. Shopify khud-ba-khud id="product_form_<n>" laga deti hai.
 * Ab `this.id` us named input ke bajaye ek STRING return karta hai. Class bodies
 * hamesha strict mode mein hoti hain, isliye string pe property set karna:
 *
 *     TypeError: Cannot create property 'disabled' on string 'product_form_8...'
 *
 * connectedCallback throw kar jata hai -> custom element ka upgrade abort ho
 * jata hai -> form ek aam <form> reh jati hai -> submit pe browser natively
 * POST karta hai /cart/add pe -> BLANK SCREEN.
 *
 * PDP (buy-buttons.liquid) pe yeh nahi hota kyunki wahan `id: form_id` pass
 * hota hai aur hidden input pe `disabled` bhi lagta hai, jise variant picker
 * alag raaste se enable karta hai.
 *
 * FIX
 * ---
 * Un forms ko dhoondo jo upgrade nahi hue, unka shadowing id attribute hata do,
 * aur customElements.upgrade() se dobara upgrade karao. Uske baad theme ka apna
 * _onSubmit chalta hai — yani cart drawer, count sync, bundled sections, sab
 * theme ke apne code se, koi duplicate logic nahi.
 *
 * Agar kisi wajah se upgrade phir bhi na ho, to neeche AJAX fallback hai jo
 * theme ke _onSubmit ka behaviour copy karta hai.
 *
 * REMOVE: theme.liquid se script tag hata dein.
 * ---------------------------------------------------------------------------
 */
(function () {
	'use strict';

	var ROOT =
		(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
	var DEBUG = /[?&]ep_debug=1/.test(window.location.search);

	function log() {
		if (!DEBUG) return;
		console.log.apply(
			console,
			['[ep-card-fix]'].concat(Array.prototype.slice.call(arguments))
		);
	}

	/* Theme ki ProductForm ka submit handler _onSubmit hai (onSubmitHandler NAHI).
	   Upgrade hone ka sabse bharosemand test: prototype chain check. */
	function isUpgraded(form) {
		var Ctor = window.customElements && window.customElements.get('product-form');
		if (!Ctor) return false;
		return form instanceof Ctor;
	}

	/* ------------------------------------------------------------------
	 * Step 1 — shadowing id attribute hatao aur dobara upgrade karao
	 * ------------------------------------------------------------------ */
	function repair(form) {
		/* Form pe id attribute hi wo cheez hai jo this.id ko string bana rahi hai.
		   Card forms pe iska koi istemal nahi (koi label/button isse reference
		   nahi karta), isliye hatana mehfooz hai. */
		var hadId = form.getAttribute('id');
		var hiddenId = form.querySelector('input[name="id"]');

		if (!hiddenId) {
			log('skip — koi input[name=id] nahi', form);
			return false;
		}

		/* Agar koi element is form ko id se reference kar raha hai to mat chhero */
		if (hadId && document.querySelector('[form="' + CSS.escape(hadId) + '"]')) {
			log('skip — id kisi aur jagah use ho rahi hai:', hadId);
			return false;
		}

		if (hadId) {
			form.removeAttribute('id');
			log('id attribute hataya:', hadId);
		}

		/* Hidden input enabled hona chahiye warna variant id submit nahi hogi */
		hiddenId.disabled = false;

		/* Dobara upgrade karao */
		if (window.customElements && window.customElements.upgrade) {
			try {
				window.customElements.upgrade(form);
			} catch (e) {
				log('upgrade() throw kar gaya', e);
			}
		}

		if (isUpgraded(form)) {
			log('upgrade kaamyab — ab theme ka apna handler chalega', form);
			return true;
		}

		log('upgrade phir bhi nahi hua, AJAX fallback lagate hain', form);
		return false;
	}

	/* ------------------------------------------------------------------
	 * Step 2 — fallback (sirf tab jab upgrade na ho saka)
	 * ------------------------------------------------------------------ */
	function setBusy(form, state) {
		var btns = form.querySelectorAll('[type="submit"]');
		for (var i = 0; i < btns.length; i++) {
			if (state) {
				btns[i].setAttribute('disabled', 'disabled');
				btns[i].setAttribute('aria-busy', 'true');
			} else {
				btns[i].removeAttribute('disabled');
				btns[i].removeAttribute('aria-busy');
			}
		}
	}

	function fallbackSubmit(form, event) {
		event.preventDefault();

		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}

		setBusy(form, true);

		/* Theme ki tarah bundled sections maangte hain taake cart drawer
		   apne aap refresh ho jaye */
		var sections = ['variant-added'];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sections }
			})
		);

		var hidden = form.querySelector('input[name="id"]');
		var variantId = hidden ? hidden.value : null;

		var fd = new FormData(form);
		fd.set('sections', sections.join(','));
		if (variantId) {
			fd.set('sections_url', ROOT + 'variants/' + variantId);
		}

		fetch(ROOT + 'cart/add.js', {
			method: 'POST',
			body: fd,
			headers: { 'X-Requested-With': 'XMLHttpRequest' }
		})
			.then(function (res) {
				return res.json().then(function (json) {
					return { ok: res.ok, json: json };
				});
			})
			.then(function (r) {
				setBusy(form, false);

				if (!r.ok) {
					form.dispatchEvent(
						new CustomEvent('cart:error', {
							bubbles: true,
							detail: { error: r.json.description }
						})
					);
					return;
				}

				var settings =
					(window.themeVariables && window.themeVariables.settings) || {};
				if (settings.cartType === 'page' || settings.pageType === 'cart') {
					window.location.href = ROOT + 'cart';
					return;
				}

				return fetch(ROOT + 'cart.js')
					.then(function (x) { return x.json(); })
					.then(function (cart) {
						cart.sections = r.json.sections;
						var items = r.json.items ? r.json.items : [r.json];

						form.dispatchEvent(
							new CustomEvent('variant:add', {
								bubbles: true,
								detail: { items: items, cart: cart }
							})
						);
						document.documentElement.dispatchEvent(
							new CustomEvent('cart:change', {
								bubbles: true,
								detail: { baseEvent: 'variant:add', cart: cart }
							})
						);
						log('fallback ne cart mein add kiya', items);
					});
			})
			.catch(function (err) {
				setBusy(form, false);
				console.warn('[ep-card-fix] add to cart fail', err);
			});
	}

	/* ------------------------------------------------------------------
	 * Run
	 * ------------------------------------------------------------------ */
	function scan() {
		var forms = document.querySelectorAll('form[is="product-form"]');

		for (var i = 0; i < forms.length; i++) {
			var form = forms[i];

			if (form.dataset.epChecked) continue;
			form.dataset.epChecked = '1';

			/* Theme ne khud handle kar liya -> bilkul haath mat lagao */
			if (isUpgraded(form)) {
				log('pehle se theek hai, chhora', form);
				continue;
			}

			/* Pehle asli fix try karo */
			if (repair(form)) continue;

			/* Warna fallback bind karo */
			(function (f) {
				f.addEventListener('submit', function (e) {
					fallbackSubmit(f, e);
				});
			})(form);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scan);
	} else {
		scan();
	}

	/* Custom elements async upgrade hote hain — theme ko mauqa dene ke baad
	   dobara dekhte hain */
	window.addEventListener('load', scan);
	setTimeout(scan, 400);
	setTimeout(scan, 1500);

	/* Baad mein render hone wale cards (carousel, pagination, section reload) */
	document.addEventListener('shopify:section:load', scan);

	if (window.MutationObserver) {
		var queued = false;
		new MutationObserver(function () {
			if (queued) return;
			queued = true;
			setTimeout(function () {
				queued = false;
				scan();
			}, 150);
		}).observe(document.body, { childList: true, subtree: true });
	}

	log('loaded');
})();
